import React from 'react'
import TabsFlightHotal from '../components/TabsFlightHotal'
import HeaderBottom from "../assets/header-bottom-shap.png"
import bannerDeals from "../assets/banner-deals.png"; 
import TopDeals from '../components/TopDeals';
import TheseProperties from '../components/TheseProperties';
import { useTranslation } from 'react-i18next'


const Deals = () => {
  const { t } = useTranslation();

  return (
    <main className="main position-relative">
        <div className="bottom-main-shap position-absolute top-0">
            <img src={HeaderBottom} alt="" />
        </div>
        <TabsFlightHotal />
         <div className="trending-destinations-sec mt-md-5 mt-4 mb-md-5 mb-4 position-relative z-1">
          <div className="container">
            <div className="deals-banner-sec position-relative">
              <div className="banner-img">
                <img src={bannerDeals} alt="Deals Banner" />
              </div>
              <div className="banner-text">
                <h2>{t("weekendTitle")}</h2>
              </div>
            </div>
            <div className="trip-right-sec pt-5 ps-md-5 pe-md-5">
              <div className="mb-md-5 mb-4">
                <TheseProperties />
              </div>
              <div className="mb-md-5 mb-4">
                <TopDeals />
              </div>
            </div>
          </div>
        </div>
    </main>
  )
}

export default Deals